import styled from "styled-components";

export const MobileContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  column-gap: 12px;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-right: 20px;
  padding-left: 20px;
  scroll-behavior: smooth;
  width: auto;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 20px;
  width: calc(100%-40px);
  height: 250px;

  img {
    object-fit: contain;
    height: 250px;
  }

  @media screen and (min-width: 768px) {
    height: 300px;
    object-fit: contain;

    img {
      object-fit: contain;
      height: 300px;
    }
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  column-gap: 16px;
  padding-left: 10%;
`;
